import * as React from 'react';
import styles from './option-icon.scss';
export interface OptionIconProps {
  iconUrl: string;
}

export class OptionIcon extends React.Component<OptionIconProps, any> {
  public render() {
    const { iconUrl } = this.props;
    return <img className={styles.optionIcon} src={iconUrl} />;
  }
}
